/** @param {unknown} err axios / request 错误 */
export function isNetworkError(err) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true;
  const code = String(err?.code ?? '');
  if (code === 'ERR_NETWORK' || code === 'ECONNABORTED') return true;
  const message = String(err?.message ?? '');
  if (/network error/i.test(message)) return true;
  if (!err?.response && err?.request) return true;
  return false;
}

/** @param {unknown} err */
export function isRequestTimeout(err) {
  const code = String(err?.code ?? '');
  if (code === 'ECONNABORTED') return true;
  return /timeout/i.test(String(err?.message ?? ''));
}

/** @param {unknown} err @returns {'network' | 'server'} */
export function classifyFeedFetchError(err) {
  if (isNetworkError(err)) return 'network';
  return 'server';
}

/**
 * @param {unknown} err
 * @param {(key: string) => string} t
 */
export function resolveRequestErrorMessage(err, t) {
  if (isNetworkError(err)) {
    return t('errors.networkUnavailable');
  }
  if (isRequestTimeout(err)) {
    return t('errors.requestTimeout');
  }
  const message = String(err?.message ?? '').trim();
  if (message && !/^network error$/i.test(message)) {
    return message;
  }
  return t('markets.loadFailed');
}
